import { createFileRoute } from '@tanstack/react-router'
import { AvailabilityEditorPage } from '../../../../modules/bookings/availability-editor-page'

export const Route = createFileRoute('/_authed/bookings/availability/$id')({
  component: AvailabilityEditorRoute,
})

function AvailabilityEditorRoute() {
  const { id } = Route.useParams()
  return <AvailabilityEditorPage scheduleId={id} />
}
